import { useEffect, useState } from 'react';

import { fetchCollatedReport } from '@utils/collatedReport';

const EMPTY_AVAILABILITY: ReadonlySet<string> = new Set();

/**
 * The requisition list payload omits `collated_report`, so a download can only be
 * offered after probing each requisition's detail endpoint for an actual report file.
 */
export const useCollatedReportAvailability = (requisitionIds: string[]): ReadonlySet<string> => {
  const [available, setAvailable] = useState(EMPTY_AVAILABILITY);
  // Joined so a fresh array of the same ids does not re-probe.
  const idKey = requisitionIds.join(',');

  useEffect(() => {
    if (!idKey) {
      setAvailable(EMPTY_AVAILABILITY);
      return;
    }

    let isActive = true;

    Promise.all(
      idKey.split(',').map(id =>
        fetchCollatedReport(id, { suppressErrorToast: true })
          .then(report => (report ? id : null))
          .catch(() => null),
      ),
    ).then(results => {
      if (isActive) setAvailable(new Set(results.filter((id): id is string => id !== null)));
    });

    return () => {
      isActive = false;
    };
  }, [idKey]);

  return available;
};
